module.exports = __webpack_public_path__ + "img/ban-parking.4ce67853.svg";